module.exports = __webpack_public_path__ + "static/media/plusRound.d6393970.svg";